import { render } from "./B2CExplanation.vue?vue&type=template&id=4b80adf5&scoped=true&lang=pug"
import script from "./B2CExplanation.vue?vue&type=script&setup=true&lang=js"
export * from "./B2CExplanation.vue?vue&type=script&setup=true&lang=js"

import "./B2CExplanation.vue?vue&type=style&index=0&id=4b80adf5&scoped=true&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b80adf5"]])

export default __exports__